import { ProductFeature, ProductFeatureV2 } from '@chilipiper/api-client/src/user-availability'

export const getCrmExplicitsFromMeetingAttemptProductFeature = (
  productFeature?: ProductFeatureV2 | ProductFeature
) => {
  if (productFeature?.type === 'HandoffRouting') {
    return
  }

  return productFeature?.crmExplicits
}
